export enum EducationType {
  Language = 1,
  Secondary = 2,
  Higher = 3,
}

export const EDUCATION_TYPES_MAP = {
  [EducationType.Language]: "Language School",
  [EducationType.Secondary]: "Secondary Education",
  [EducationType.Higher]: "Higher Education",
};

export const EDUCATION_TYPES = [
  {
    id: EducationType.Language,
    name: EDUCATION_TYPES_MAP[EducationType.Language],
  },
  {
    id: EducationType.Secondary,
    name: EDUCATION_TYPES_MAP[EducationType.Secondary],
  },
  {
    id: EducationType.Higher,
    name: EDUCATION_TYPES_MAP[EducationType.Higher],
  },
];
